/** Window event name used to request that a resolved thread expand to reveal a comment. */
export const PR_V2_REVEAL_COMMENT_EVENT = 'pr-v2:reveal-comment';

export type PrV2RevealCommentPayload = {
  commentId: string;
};

/** Dispatches a browser event asking any thread card containing the comment to expand. */
export function dispatchPrV2RevealComment(commentId: string): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent<PrV2RevealCommentPayload>(PR_V2_REVEAL_COMMENT_EVENT, {
      detail: { commentId },
    }),
  );
}
